<pbc-sorter [config]="TageSorterConfig" [sorter]="tage.sorter$ | async" (sorterChange)="tage.sorter$.next($event)"></pbc-sorter>
